import React, {useEffect, useState} from "react";
import "./Devices.css";
import Device from "./Device";
import Row from "react-bootstrap/Row";
import LoadingIcon from "components/dasboardv3/components/Partials/LoadingIcon/LoadingIcon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHouse} from "@fortawesome/free-solid-svg-icons";

window.isLoadingDevices = false;

function Devices({bond, reloadTimestamp, setDevicesById}) {
    const [devicesByLocation, setDevicesByLocation] = useState({});
    const [isLoadingDevices, setIsLoadingDevices] = useState(false);

    async function reloadDevices() {
        setIsLoadingDevices(true);

        let devices = await bond.devices();

        let _devicesByLocation = {};
        let _devicesById = {};

        for (let deviceId in devices) {
            let device = devices[deviceId];
            if (_devicesByLocation[device.data.location] === undefined) _devicesByLocation[device.data.location] = [];

            _devicesByLocation[device.data.location].push(device);
            _devicesById[device.deviceId] = device.data
        }

        setDevicesByLocation(_devicesByLocation);
        setDevicesById(_devicesById);
        setIsLoadingDevices(false);
    }

    useEffect(() => {
        if (reloadTimestamp && !window.isLoadingDevices) {
            setIsLoadingDevices(true);
            window.isLoadingDevices = true;
            reloadDevices().then(() => {
                window.isLoadingDevices = false
            });
        }
    }, [reloadTimestamp]);

    return (<div>
        {isLoadingDevices ? <div className={"d-flex justify-content-center m-2"}><LoadingIcon/></div> : (<>
            {Object.keys(devicesByLocation).sort().map((location, index) => (<div key={location}>
                {index !== 0 && <hr/>}
                <h4 className={"text-muted locationTitle"}><FontAwesomeIcon icon={faHouse} size={"sm"}/> {location}</h4>
                <Row xs={1} md={2} xl={3} className={"devicesRow"}>
                    {devicesByLocation[location].map(d => (<Device key={d.deviceId} device={d}/>))}
                </Row>
            </div>))}
        </>)}
    </div>);
}

export default Devices;
